import { ToolbarBreadcrumbs } from "./toolbar";
import type { PortalType } from "@/lib/breadcrumb";

export function HeaderBreadcrumbs({ portalType }: { portalType?: PortalType }) {
  return (
    <div className="flex flex-row items-center flex-wrap gap-1 lg:gap-5 mb-5 lg:mb-0">
      <ToolbarBreadcrumbs portalType={portalType} />
    </div>
  );
}
